/**
 * AuthRoute — Route guard that requires authentication.
 *
 * Waits for AuthContext.isLoading to resolve before making access decisions.
 * Prevents the flash-of-redirect problem on new tab navigation.
 */

import React from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '../../context/AuthContext'

interface AuthRouteProps {
  children: React.ReactNode
}

export const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const { isLoading, isAuthenticated } = useAuth()

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px', color: '#666' }}>
        Loading...
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
